<template>
    <b-modal :visible="Visible" @hide="onClose()" @close="onClose()" centered @hidden="clear();">
        <template #modal-title>
            <!-- $t('SavedScopes') / Périmètres enregistrés -->
            <h6>{{ $t('SavedScopes') }}</h6>
        </template>

        <!-- Tableau d'affichage avec pagination des masques de configuration -->
        <b-table fixed :id="$id('masksList')" responsive selectable select-mode="single" :items="filters" :fields="fieldsFilters" 
        :per-page="itemPerPage" :current-page="currentPage" thead-class="d-none" tbody-tr-class="d-flex" @row-selected="filterRowSelected" >
                    <template #cell(Label)="data">
                            {{data.value}}
                    </template>
                    
                    <template #cell(Id)="data" >
                        <b-icon @click="$emit('DeleteFilterEvent', data.value);" role="button" icon="x" scale="2"  />
                    </template>
                </b-table>
                
        <template #modal-footer="{ cancel }">
            <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="itemPerPage" class="mr-auto" />
            <!-- $t('Cancel') / Annuler -->
            <b-button :variant="'outline-' + Variant" pill @click="cancel();">{{ $t('Cancel') }}</b-button>
            <!-- $t('Apply') / Appliquer -->
            <b-button :variant="Variant" pill @click="load(); cancel();" :disabled="selectedPerimeter == null">{{ $t('Apply') }}</b-button>
        </template>
    </b-modal>
</template>

<script lang="ts">
    import { Component, InjectReactive, Model, Prop, Vue, Watch } from 'vue-property-decorator';
    import ListItem from '@/types/fields/ListItem';
    import FilterT from '@/types/FilterTree/FilterT';
    import locales from '../locales/SavedFilters.json'

    /** Composant de chargement de listes enregistrées de filtres */
    @Component({
        components: {

        },
        i18n:{messages: locales}
    })
    export default class SavedFilters extends Vue {
        /** Variant de couleur à appliquer sur le composant */
        @InjectReactive()
        public Variant!: string;

        /** @todo : mettre affichage/masquage modale par v-model dans une classe commune à hériter ? */
		//#region Affichage/masquage de la modale par v-model
        @Model('SavedFiltersVisibleEvent', { default:  false }) /** type: boolean, */
        public Visible!: boolean;
        private visible: boolean = false;

		@Watch('Visible')
        private updateVisible() {
            this.visible = this.Visible;
        }

        private onClose() {
            this.visible = false;
            this.$emit('SavedFiltersVisibleEvent', this.visible);
        }
        //#endregion Affichage/masquage de la modale par v-model

		/** Nom du store Vuex persistant l'arborescence */
		@Prop()
		public FilterTreeStore!: string;

        private filters: ListItem[] = [];

        /** Tableau des colonnes des périmètres à afficher */
        private fieldsFilters = [
            {
                key:"Label",
                label:"",
                tdClass:"text-truncate w-100"
            },
            {
                key:"Id",
                label:"",
                tdClass:"text-danger"
            }
        ];

        /** Numero de la page courante de la pagination des périmètres */
        private currentPage: number = 1;

        /** Nombre d'éléments à afficher par page */
        private itemPerPage: number = 5;

        /** Nombre de ligne de données pour la pagination  */
        private totalRows: number = 1;

        /**
         * Sélectionne l'identifiant du masque afin de l'appliquer
         * @param row Ligne dans le tableau des masques
         */
        private filterRowSelected(row) {
            console.debug("SavedFilters - maskRowSelected - row :", row);
            if(row.length == 1)
                this.selectedPerimeter = { Id: row[0].Id, Label: row[0].label } as ListItem;
            else
                this.selectedPerimeter = undefined;
        }

        /** Filtre sélectionné dans le b-form-select lié à filters */
        private selectedPerimeter: ListItem = null;

        private load() {
            if (this.selectedPerimeter != undefined) {
                let filter: FilterT = { Id: this.selectedPerimeter.Id.toString(), Name: "", Remark: "", Color: "", Pins: [] } as FilterT;
                this.$store.dispatch(this.FilterTreeStore + "/LoadFilter", { filter: filter });
            }
        }

        /** Réinitialisation de la liste des filtres */
        private clear() {
            this.selectedPerimeter = undefined;
        }

        /** 
         * Pointeur vers fonction pour désactiver watchers
         * @see https://vuejs.org/guide/essentials/watchers#stopping-a-watcher
         **/
        private unwatchGetFilters = undefined;

        mounted() {
            this.unwatchGetFilters = this.$store.watch((state, getters) => getters[this.FilterTreeStore + '/GetFilters'](), val => {
				this.filters = val;
				this.totalRows = this.filters.length;
			}, { immediate: true });
        }

        beforeDestroy() {
            // Libère les watchers
            if (this.unwatchGetFilters)
                this.unwatchGetFilters();
        }
    }
</script>

<style scoped>
</style>